import placeholderImg from "../assets/placeholder-img.png";

export const PLACEHOLDER_IMG = placeholderImg;

// Resolves a menu item's image URL, falling back to the placeholder when the
// item has no image stored.
export function getMenuItemImage(item) {
  const path = item?.image;
  if (!path || String(path).trim() === "") return placeholderImg;
  return `https://lasgidirestaurant.com/${path}`;
}

// Swaps in the placeholder when the remote image fails to load (404, broken
// path, etc.) instead of showing the browser's raw alt text.
// Clearing onerror first prevents a loop if the placeholder itself ever fails.
export function handleMenuImageError(e) {
  if (e?.target?.src === placeholderImg) return;
  e.target.onerror = null;
  e.target.src = placeholderImg;
}
